import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { HeaderContent } from '../../../types/reports';
import './styles.css';

interface Props {
  headerContent?: HeaderContent;
  isLoading?: boolean;
}

export default function ReportHeader({ headerContent, isLoading }: Props) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  if (!headerContent) return null;

  return (
    <Box
      padding={2}
      gap={2}
      display="flex"
      flexDirection={isMd ? 'row' : 'column'}
      justifyContent="space-between"
      alignItems={isMd ? 'center' : 'start'}
      borderBottom={`1px solid ${theme.palette.darkerLightGrey.main}`}>
      <Box flexGrow={1}>
        <Typography variant="h3" fontWeight="bold">
          {headerContent.title}
        </Typography>
        <Typography variant="body2">{headerContent.subtitle}</Typography>
      </Box>
      {headerContent.action && (
        <Button
          disabled={isLoading || headerContent.action.disabled}
          variant="outlined"
          className="virtualized-table-action-button"
          color="inherit"
          style={{
            borderRadius: '10px',
          }}
          startIcon={headerContent.action.icon}
          onClick={headerContent.action.onClick}>
          <Typography variant="body2">{headerContent.action.label}</Typography>
        </Button>
      )}
    </Box>
  );
}
